/* Intertaal collection banner link helpers — 09-09-2026 */
(function () {
  var PRODUCT_ANCHOR = 'intertaal-collection-search';
  var BANNER_LINK_SELECTOR = [
    '.collection-landing-intro__actions a',
    '.collection-landing-intro__shortcuts a',
    '.theme-landing__routes a',
    '.language-landing__routes a',
    '.publisher-landing__routes a',
    '.study-subject-intro__routes a'
  ].join(',');

  function scrollToCollectionRoot(collectionRoot) {
    if (!collectionRoot) return;
    collectionRoot.style.scrollMarginTop = '104px';
    collectionRoot.scrollIntoView({ block: 'start', behavior: 'auto' });
  }

  function directCollectionLinksToProducts() {
    document.querySelectorAll(BANNER_LINK_SELECTOR).forEach(function (link) {
      if (!link.getAttribute('href')) return;

      try {
        var url = new URL(link.href, window.location.origin);
        if (url.origin !== window.location.origin) return;
        if (url.pathname.indexOf('/collections/') !== 0) return;

        url.hash = PRODUCT_ANCHOR;
        link.href = url.pathname + url.search + url.hash;
      } catch (error) {
        /* Leave an invalid or non-standard link untouched. */
      }
    });
  }

  function initCollectionBannerLinks() {
    var collectionRoot = document.querySelector('[data-section-type="collection"]');
    if (collectionRoot && !document.getElementById(PRODUCT_ANCHOR)) {
      collectionRoot.id = PRODUCT_ANCHOR;
    }

    directCollectionLinksToProducts();

    if (collectionRoot && window.location.hash === '#' + PRODUCT_ANCHOR) {
      window.requestAnimationFrame(function () {
        scrollToCollectionRoot(collectionRoot);
      });
      window.setTimeout(function () {
        scrollToCollectionRoot(collectionRoot);
      }, 120);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCollectionBannerLinks, { once: true });
  } else {
    initCollectionBannerLinks();
  }

  document.addEventListener('shopify:section:load', initCollectionBannerLinks);
})();
